import { jsx as _jsx } from "react/jsx-runtime";
import { Card, Dialog } from '@mui/material';
import { useContext } from 'react';
import { ProcessReceptionAreaRequestStatus } from '../CloudSideTypes';
import { NetworkCoverageContext } from '../NetworkCoverageContext';
import { RequestStatusIndicator } from './RequestStatusIndicator';
export const RequestStatusPopup = () => {
    // coverage report generation / requests state
    const { state: { requestStatusMap }, } = useContext(NetworkCoverageContext);
    const totalRequests = Object.values(requestStatusMap).length;
    let resolvedRequests = 0;
    Object.entries(requestStatusMap).forEach(([_, v]) => {
        if (ProcessReceptionAreaRequestStatus.PENDING < v.status)
            resolvedRequests++;
    });
    const open = 0 < totalRequests && resolvedRequests !== totalRequests;
    return (_jsx(Dialog, { open: open, children: _jsx(Card, { sx: { padding: 2 }, children: _jsx(RequestStatusIndicator, { withProgressBar: true }) }) }));
};
